export default __webpack_public_path__ + "static/media/placing-3.d6fec1be.svg";